window.faturamentoOutrasSaidasController = ControllerBase.extend({
    name: 'faturamentoOutrasSaidasController',
    framework: 'knockout',

    ajax: function () {
        return {
            url: '/Orcamento/_FaturamentoOutrasSaidas',
            type: 'post',
            cache: false,
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento")
            }
        };
    },

    antesBinding: function () {
        this.appendToModel({ name: "DespositoObrigatorio", value: false });
        this.appendToModel({ name: "MensagemObrigatorio", value: false });
    },

    aposBinding: function () {
        this.controlarCampos()
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },

    controlarCampos: function () {
        if (this.readOnly)
            return;
        if (this.model.MercadoriaComRetorno()) {
            this.MercadoriaComRetornoAlterado()
        } else{
            this.OperacaoTributadaAlterado()
        }
    },

    MercadoriaComRetornoAlterado: function () {
        if (this.model.MercadoriaComRetorno()) {
            this.model.OperacaoTributada(0);
            this.model.CodigoMensagemTributaria("");
        } else {
            this.model.CodigoDepositoDestino("")
            this.model.OperacaoTributada(1);
        }
        this.ControlarObrigatorios();
    },

    OperacaoTributadaAlterado: function () {
        if (this.model.OperacaoTributada()) {
            this.model.MercadoriaComRetorno(0)
            this.model.CodigoDepositoDestino("")
            this.model.CodigoMensagemTributaria("");
        }
        this.model.DespositoObrigatorio(this.model.MercadoriaComRetorno())
        this.model.MensagemObrigatorio(!this.model.MercadoriaComRetorno() && !this.model.OperacaoTributada());
        this.ControlarObrigatorios();
    },
    
    ControlarObrigatorios: function (){
        this.model.DespositoObrigatorio(this.model.MercadoriaComRetorno())
        this.model.MensagemObrigatorio(!this.model.MercadoriaComRetorno() && !this.model.OperacaoTributada());

        if (!this.model.DespositoObrigatorio())
            $('#form-faturamento-outras-saidas #Deposito').removeClass('erro');
        if (!this.model.MensagemObrigatorio())
            $('#form-faturamento-outras-saidas #Mensagem').removeClass('erro');
    },

    formConfig: {
        selector: "#form-faturamento-outras-saidas",
        submit: {
            selector: "#aplicar-outras-saidas",
            loadingText: "Aguarde...",
            callback: "aplicar",
            type: "model",
            modelType: "js"
        },
        rules: {
            'Deposito': {
                required: function () { return this.model.DespositoObrigatorio(); },
            },
            'Mensagem': {
                required: function () { return this.model.MensagemObrigatorio(); },
            }
        },
        messages: {
            'Deposito': {
                required: 'O campo "Depósito" é obrigatório.',
            },
            'Mensagem': {
                required: 'O campo "Mensagem" é obrigatório.',
            }
        },
        ignore: [],
    },

    aplicar: function (model, e) {
        e.preventDefault();
        if (!global.isFormValid("#form-faturamento-outras-saidas")) {
            return;
        }
        var self = this;

        global.ajax({
            url: "/Orcamento/SalvarDadosFaturamentoOutrasSaidas",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                dadosFaturamento: this.toJS(self.model),
            }),
            success: function (data) {
                if (!data || data.HasErrors) {
                    return;
                }
                global.showSuccessMessage("Dados de faturamento atualizados com sucesso.");
                self.atualizar(data);
            }
        });
    },

    atualizar: function (data) {
        this.model.MercadoriaComRetorno(data.MercadoriaComRetorno);
        this.model.CodigoDepositoDestino(data.CodigoDepositoDestino);
        this.model.OperacaoTributada(data.OperacaoTributada);
        this.model.CodigoMensagemTributaria(data.CodigoMensagemTributaria);
        this.controlarCampos();
    },

});